import { ActionButtonModel } from './action-button.model';
import {
  IActionButtonsApiModel,
  IBtrEventApiModel,
  ICuratedCategoryModel,
  IDealApiModel,
  IPlaceApiV5Model,
  IRegularCategoryModel,
} from './api';
import { BtrEventModel } from './btr-event.model';
import { CuratedCategoryModel } from './curated-category.model';
import { DealModel } from './deal.model';

export class PlaceModel {
  id: number;
  title: string;
  titleWeb: string;
  slug: string;
  subtitle: string | null;
  description: string | null;
  imageUrl: string | null;
  imageUrls: Array<string> | null;
  emojiUrl: string;
  locationInfo: {
    point: {
      latitude: number;
      longitude: number;
    };
    googlePlaceId: string;
    name: string;
    address: string;
  };
  isBookmarked: boolean | null;
  isDeleted: boolean | null;
  contactInfo: IPlaceApiV5Model['contact_info'];
  // owners: Array<any> | null;

  regularCategories: Array<IRegularCategoryModel> | null;
  isFeatured: boolean | null;

  eventDescription?: string;

  private _curatedCategories: Array<ICuratedCategoryModel> | null;
  private _deals: Array<IDealApiModel> | null;
  private _events: Array<IBtrEventApiModel> | null;
  private _actionButtons: Array<IActionButtonsApiModel> | null;

  get curatedCategories(): Array<CuratedCategoryModel> {
    return this._curatedCategories
      ? this._curatedCategories.map(item => new CuratedCategoryModel(item))
      : [];
  }

  get featuredTags(): Array<CuratedCategoryModel> {
    return this.curatedCategories?.length
      ? this.curatedCategories.filter(item => item.isTag && item.isFeatured)
      : null;
  }

  get deals(): Array<DealModel> {
    return this._deals ? this._deals.map(item => new DealModel(item)) : [];
  }

  get events(): Array<BtrEventModel> {
    return this._events
      ? this._events.map(item => new BtrEventModel(item))
      : [];
  }

  get actionButtons(): Array<ActionButtonModel> {
    return this._actionButtons
      ? this._actionButtons.map(item => new ActionButtonModel(item))
      : [];
  }

  constructor(source?: IPlaceApiV5Model) {
    if (source == null) {
      return;
    }

    this.id = source.id;
    this.title = source.title;
    this.titleWeb = source.title_web;
    this.slug = source.slug;
    this.subtitle = source.subtitle;
    this.description = source.description_page?.body ?? source.description;
    this.imageUrl = source.image_url;
    this.imageUrls = source.image_urls;
    this.emojiUrl = source.emoji_url;
    this.isBookmarked = source.is_bookmarked;
    this.isDeleted = source.is_deleted;
    this.contactInfo = source.contact_info;
    this.isFeatured = source.is_featured;
    this.eventDescription = source.event_description ?? null;

    this.locationInfo = source.location_info
      ? {
          point: source.location_info.point,
          googlePlaceId: source.location_info.google_place_id,
          name: source.location_info.name,
          address: source.location_info.address,
        }
      : null;

    this._actionButtons = source.action_buttons;
    this.regularCategories = source.categories_regular;
    this._curatedCategories = source.categories_curated;
    this._deals = source.coupons;
    this._events = source.events;
  }

  static copyObj(source: Pick<PlaceModel, keyof PlaceModel>): PlaceModel {
    return Object.assign(new PlaceModel(), source);
  }
}

export enum PlaceContactType {
  DEFAULT = 0,
  TAGS,
  WEBSITE,
  PHONE,
  ADDRESS,
}

export type IPlaceContactModel = PlaceModel['contactInfo'][number] & {
  type: PlaceContactType;
};
